import React, { useEffect } from "react";

// Hooks
import { useCustomerCreate, useCustomerIndex } from "../../../../hooks/api/fulfillment/customer";
import useOrderCreateFlow from "../../../../hooks/reduxContainer/fulfillment/orderCreateFlow";

// Components
import { SearchCustomer } from "@secondcloset/web-components";
import { notification } from "antd";

// helper
import { get } from "lodash-es";
import { useParams } from "react-router";

// interfaces
import { Customer } from "@secondcloset/types/src/fulfillment";
import { useFacilityLookup } from "../../../../hooks/api/common/useFacilityIndex";
import { Facility } from "../../../../api/common/facility";

export interface CreateCustomerBodyInfo {
  name: string;
  email_address: string;
  phone_number: string;
}
const PER_PAGE = 10000;

const SearchCustomerStep = () => {
  const { activeCustomer, dispatchActiveCustomer } = useOrderCreateFlow();
  const params = useParams();
  const organizationID = get(params, "organization_id");
  const { customerIndex, fetchCustomerIndex } = useCustomerIndex(organizationID);
  const { customerCreateDetails, createCustomer, resetCustomerCreateDetails } = useCustomerCreate(organizationID);
  const facilityLookup = useFacilityLookup();
  useEffect(() => {
    if (customerCreateDetails.error) {
      notification.error({
        message: "Create customer failed",
        description: (customerCreateDetails.error as unknown as string)?.toString(),
      });
    }
  }, [customerCreateDetails.error]);

  const onCustomerCreated = () => {
    if (customerCreateDetails.data && !customerCreateDetails.error) {
      dispatchActiveCustomer(customerCreateDetails.data);
      fetchCustomerIndex();
    }
  };
  useEffect(onCustomerCreated, [customerCreateDetails.data, customerCreateDetails.error]);

  const fetchCustomers = (searchString: string) => {
    dispatchActiveCustomer(null);
    fetchCustomerIndex({ q: searchString.trim(), per_page: PER_PAGE });
  };

  const createNewCustomer = (customerInfo: CreateCustomerBodyInfo) => {
    resetCustomerCreateDetails();
    createCustomer(customerInfo.name, customerInfo.email_address, customerInfo.phone_number);
  };

  return (
    <SearchCustomer
      customers={((customerIndex?.data || []) as Customer[]).filter((c) => !facilityLookup[c.name as Facility["name"]])}
      selectedCustomerId={activeCustomer?.id}
      customerSearchLoading={customerIndex?.loading}
      onCustomerSearch={fetchCustomers}
      onCustomerSelect={dispatchActiveCustomer}
      onCreateCustomer={(customerInfo) => createNewCustomer(customerInfo)}
    />
  );
};

export default SearchCustomerStep;
